module.exports = __webpack_public_path__ + "img/MOU.698fb580.jpeg";